import { render, staticRenderFns } from "./FrequentAbsencesDialog.vue?vue&type=template&id=75dce026"
import script from "./FrequentAbsencesDialog.vue?vue&type=script&lang=js"
export * from "./FrequentAbsencesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports